import Script from 'next/script';
import { useRouter } from 'next/router';
import { useCookieConsent } from '@/context/CookieConsentContext';

const GOOGLE_TAG_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_ID || 'G-3LM6MDQBG2';
const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID || '1492352965755226';
const META_PIXEL_ID_2 = process.env.NEXT_PUBLIC_META_PIXEL_ID_2 || '';
const META_REQUIRES_COOKIE_CONSENT = process.env.NEXT_PUBLIC_META_REQUIRES_COOKIE_CONSENT === 'true';
const TIKTOK_PIXEL_ID = process.env.NEXT_PUBLIC_TIKTOK_PIXEL_ID || 'D7V4HO3C77UEPF9K059G';
const GTM_ID = 'GTM-TT2C8TC2';

export default function TrackingScripts() {
  const router = useRouter();
  const { hasTrackingConsent, isReady } = useCookieConsent();
  const isAdminRoute = router.route === '/admin';

  if (!isReady || isAdminRoute) {
    return null;
  }

  return (
    <>
      {GOOGLE_TAG_ID ? (
        <>
          <Script
            id="google-tag-src"
            src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_TAG_ID}`}
            strategy="afterInteractive"
          />
          <Script id="google-tag-base" strategy="afterInteractive">
            {`
              window.dataLayer = window.dataLayer || [];
              window.gtag = window.gtag || function(){window.dataLayer.push(arguments);};
              window.gtag('consent', 'default', {
                analytics_storage: '${hasTrackingConsent ? 'granted' : 'denied'}',
                ad_storage: '${hasTrackingConsent ? 'granted' : 'denied'}',
                ad_user_data: '${hasTrackingConsent ? 'granted' : 'denied'}',
                ad_personalization: '${hasTrackingConsent ? 'granted' : 'denied'}'
              });
              window.gtag('js', new Date());
              window.gtag('config', '${GOOGLE_TAG_ID}', {
                send_page_view: false
              });
            `}
          </Script>
        </>
      ) : null}
      {META_PIXEL_ID && (!META_REQUIRES_COOKIE_CONSENT || hasTrackingConsent) ? (
        <>
          <Script id="meta-pixel-base" strategy="afterInteractive">
            {`
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '${META_PIXEL_ID}');
              ${META_PIXEL_ID_2 ? `fbq('init', '${META_PIXEL_ID_2}');` : ''}
            `}
          </Script>
          <noscript>
            <img
              height="1"
              width="1"
              style={{ display: 'none' }}
              src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`}
            />
            {META_PIXEL_ID_2 ? (
              <img
                height="1"
                width="1"
                style={{ display: 'none' }}
                src={`https://www.facebook.com/tr?id=${META_PIXEL_ID_2}&ev=PageView&noscript=1`}
              />
            ) : null}
          </noscript>
        </>
      ) : null}
      {!isReady || !hasTrackingConsent ? null : (
        <>
          <Script id="gtm-base" strategy="afterInteractive">
            {`
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${GTM_ID}');
            `}
          </Script>
          {TIKTOK_PIXEL_ID ? (
            <Script id="tiktok-pixel-base" strategy="afterInteractive">
              {`
                !function (w, d, t) {
                  w.TiktokAnalyticsObject=t;
                  var ttq=w[t]=w[t]||[];
                  ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
                  ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))};};
                  for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
                  ttq.instance=function(t){var e=ttq._i[t]||[];for(var n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e;};
                  ttq.load=function(e,n){
                    var r="https://analytics.tiktok.com/i18n/pixel/events.js";
                    o=n&&n.partner;
                    ttq._i=ttq._i||{};
                    ttq._i[e]=[];
                    ttq._i[e]._u=r;
                    ttq._t=ttq._t||{};
                    ttq._t[e]=+new Date;
                    ttq._o=ttq._o||{};
                    ttq._o[e]=n||{};
                    var o=document.createElement("script");
                    o.type="text/javascript";
                    o.async=!0;
                    o.src=r+"?sdkid="+e+"&lib="+t;
                    var a=document.getElementsByTagName("script")[0];
                    a.parentNode.insertBefore(o,a);
                  };
                  ttq.load('${TIKTOK_PIXEL_ID}');
                }(window, document, 'ttq');
              `}
            </Script>
          ) : null}
        </>
      )}
    </>
  );
}
